'use client';

import { useEffect } from 'react';

export default function ServiceWorkerRegistration() {
  useEffect(() => {
    if (!('serviceWorker' in navigator)) return;

    const register = async () => {
      try {
        const reg = await navigator.serviceWorker.register('/sw.js');
        // When a new SW takes over, reload once so the user gets fresh
        // content instead of a mix of old and new chunks.
        let refreshing = false;
        navigator.serviceWorker.addEventListener('controllerchange', () => {
          if (refreshing) return;
          refreshing = true;
          window.location.reload();
        });
        // Check for updates every time the page becomes visible.
        reg.update();
      } catch {
        // Non-fatal — SW is a progressive enhancement.
      }
    };

    void register();

    // Re-check for SW updates when the tab regains focus.
    const onFocus = () => {
      navigator.serviceWorker.getRegistration('/').then((reg) => reg?.update());
    };
    window.addEventListener('focus', onFocus);

    return () => window.removeEventListener('focus', onFocus);
  }, []);

  return null;
}
